import { z } from 'my-zod'
import { extendedProductLineOptions } from '../../internal'
// import { CatalogProductTypeEnum } from '../../customer-operations/product/product-base-fragment'

export const WaiverDataPerson = z.object({
  guestId: z.string(),
  firstName: z.string().nullable(),
  lastName: z.string().nullable()
})

export type WaiverDataPerson = z.infer<typeof WaiverDataPerson>

export const waiverDataFragment = z.object({
  email: z.string().email(),

  beginDate: z.string(),
  endDate: z.string(),
  rideDate: z.string(),
  ridingTimeRange: z.string(),

  productLine: z.enum(extendedProductLineOptions).nullish(),
  productType: z.string().nullish(), // CatalogProductTypeEnum

  adult: WaiverDataPerson.nullable(),
  minors: WaiverDataPerson.array().nullable(),

  cancellationAuthorFirstName: z.string().nullish(),
  cancellationAuthorLastName: z.string().nullish(),
  cancellationDate: z.string().nullish()
})

export type waiverDataFragment = z.infer<typeof waiverDataFragment>
